import { render, staticRenderFns } from "./eventsAdd.vue?vue&type=template&id=e323e77a&scoped=true&"
import script from "./eventsAdd.vue?vue&type=script&lang=js&"
export * from "./eventsAdd.vue?vue&type=script&lang=js&"
import style0 from "./eventsAdd.vue?vue&type=style&index=0&id=e323e77a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e323e77a",
  null
  
)

export default component.exports